"use client";

import { Button } from "@/components/ui/button";
import { useRouter, useParams } from "next/navigation";
import { useTranslations } from "next-intl";

interface TryFreeButtonProps {
  variant?: "default" | "white" | "purple";
  fullWidth?: boolean;
  size?: "default" | "large";
}

export function TryFreeButton({
  variant = "default",
  fullWidth = false,
  size = "default",
}: TryFreeButtonProps) {
  const router = useRouter();
  const params = useParams();
  const locale = params.locale as string;
  const t = useTranslations("Landing");

  const handleClick = () => {
    router.push(`/${locale}/auth`);
  };

  const getButtonClasses = () => {
    const baseClasses = "rounded-lg transition-colors duration-200 font-medium";
    const widthClass = fullWidth ? "w-full" : "";
    const sizeClasses =
      size === "large"
        ? "px-4 md:px-8 py-10 text-xl"
        : "px-4 md:px-8 py-6 text-base";

    const variants = {
      default: `
            bg-brand-primary
            hover:bg-brand-accent
            text-white
        `,
      white: `
            bg-white
            hover:bg-gray-100
            text-gray-900
        `,
      purple: `
            bg-brand-accent
            hover:bg-brand-accent-light
            text-white
        `,
    };

    return `
        ${baseClasses}
        ${widthClass}
        ${sizeClasses}
        ${variants[variant]}
    `;
  };

  return (
    <Button onClick={handleClick} className={getButtonClasses()}>
      {t("tryForFree")}
    </Button>
  );
}
